import { TabData } from 'src/components/molecules/Tabs/Tabs'

import {
  adminViewPlantingPath,
  adminViewPlantingMonitoringsPath,
  adminViewPlantingPhotosPath
} from 'src/config/paths'
import { PlantingType } from 'src/types/planting'

export enum AdminPlantingNavTab {
  Details = 'details',
  Monitorings = 'monitorings',
  Photos = 'photos'
}
export function getTabs(planting: PlantingType): TabData[] {
  return [
    {
      label: 'Planting details',
      value: AdminPlantingNavTab.Details,
      path: adminViewPlantingPath({
        routeParams: {
          applicationId: planting.ApplicationId,
          plantingId: planting.Id
        }
      })
    },
    {
      label: 'Monitorings',
      value: AdminPlantingNavTab.Monitorings,
      path: adminViewPlantingMonitoringsPath({
        routeParams: {
          applicationId: planting.ApplicationId,
          plantingId: planting.Id
        }
      })
    },
    {
      label: 'Photos',
      value: AdminPlantingNavTab.Photos,
      path: adminViewPlantingPhotosPath({
        routeParams: {
          applicationId: planting.ApplicationId,
          plantingId: planting.Id
        }
      })
    }
  ]
}
